import { SCHEDULE_DELETE, SCHEDULE_SAVE, SCHEDULE_EDIT } from "../Actions/SchedulerActions";

const initialState = {
	data: [],
	hasError: false,
	errMsg: '',
	isLoading: false,
	redirect: false,
	success: false,
	successMsg: ''
};

export const roomsAll = (state = initialState, action) => {
	return makeAReducer('ROOMSALL', state, action);
};
export const accounts = (state = initialState, action) => {
	return makeAReducer('ACCOUNTS', state, action);
};
export const buildings = (state = initialState, action) => {
	return makeAReducer('BUILDINGS', state, action);
};
export const floors = (state = initialState, action) => {
	return makeAReducer('FLOORS', state, action);
};
export const rooms = (state = initialState, action) => {
	return makeAReducer('ROOMS', state, action);
};
export const roomTypes = (state = initialState, action) => {
	return makeAReducer('ROOMTYPES', state, action, true);
};
export const roomDetailTypes = (state = initialState, action) => {
	return makeAReducer('ROOMDETAILTYPES', state, action, true);
};
export const roomsDetails = (state = initialState, action) => {
	return makeAReducer('ROOMDETAILS', state, action, true);
};
export const assets = (state = initialState, action) => {
	return makeAReducer('ASSETS', state, action, true);
};
export const assetDetails = (state = initialState, action) => {
	return makeAReducer('ASSETDETAILS', state, action, true);
};
export const assetTypes = (state = initialState, action) => {
	return makeAReducer("ASSETTYPES", state, action, true);
};
export const assetDetailTypes = (state = initialState, action) => {
	return makeAReducer("ASSETDETAILTYPES", state, action);
};
export const events = (state = initialState, action) => {
	return makeAReducer("EVENTS", state, action);
};
export const reservationTypes = (state = initialState, action) => {
	return makeAReducer("RESERVATIONTYPES", state, action, true);
};
export const users = (state = initialState, action) => {
	return makeAReducer('USERS', state, action);
};
export const roles = (state = initialState, action) => {
	return makeAReducer('ROLES', state, action);
};

export const userGroups = (state = initialState, action) => {
	return makeAReducer('USERGROUPS', state, action);
};
const makeAReducer = (type, state = initialState, action, alphaSort) => {
	switch (action.type) {
		case type + '_LOADING':
			return {
				...state,
				isLoading: action.isLoading
			};
		case type + '_ERROR':
			return {
				...state,
				hasError: action.hasError
			};
		case type + '_FETCH_SUCCESS':
			let data = action.data;
			if (alphaSort && Array.isArray(data)) 					              	/* Allow sorting by name if passed in via makeAReducer function */
				data = action.data.sort(sortByName);
			return {
				...state,
				data
			};
		case type + '_ERR_MSG':
			return {
				...state,
				errMsg: action.errMsg
			};
		case type + '_REDIRECT':
			return {
				...state,
				redirect: action.redirect
			};
		case type + '_CLEAR_ERRS':
			return {
				...state,
				errMsg: '',
				hasError: false
			};
		case type + '_SUCCESS':
			return {
				...state,
				success: action.success
			};
		case type + '_SUCCESS_MESSAGE':
			let method = action.successMsg;
			let response = '';
			if (method == 'post') response = type + ' saved successfully';
			return {
				...state,
				successMsg: response
			};
		case type + '_CLEAR_SUCCESS':
			return {
				...state,
				success: false,
			};
		case type + '_CLEAR_SECONDARY_SUCCESS':
			return {
				...state,
				success: false,
			};
		case type + '_CLEAR_TERTIARY_SUCCESS':
			return {
				...state,
				success: false,
			};
		case SCHEDULE_SAVE:
			if (type === "EVENTS") {
				return {
					...state,
					data: [...state.data, action.event]
				}
			} else {
				return { ...state }
			}
		case SCHEDULE_EDIT:
			if (type === "EVENTS") {
				return {
					...state,
					data: state.data.map(
						(content, i) => content.id === action.event.id ? action.event
							: content)
				}
			} else {
				return { ...state };
			}
		case SCHEDULE_DELETE:
			if (type === "EVENTS") {
				return {
					...state,
					data: state.data.filter(
						(content, i) => content.id !== action.event.id)
				}
			} else {
				return { ...state };
			}
		default:
			return state;
	}
};
const sortByName = (a, b) => {
	if (!a.name || !b.name) {  // simple null check
		return 0;
	}
	let nameA = a.name.toUpperCase(); // ignore case
	let nameB = b.name.toUpperCase();
	if (nameA < nameB) {
		return -1;
	}
	if (nameA > nameB) {
		return 1;
	}

	return 0;
};



// WEBPACK FOOTER //
// ./src/Store/Reducers/EntityReducer.js